define('start/app',['app', 'views/AppView', 'routers/AppRouter'], function (App, AppView, AppRouter) {

    "use strict";

    App.view = new AppView();
    App.router = new AppRouter();

});
